export default __webpack_public_path__ + "static/media/Blooded Tunic of the Ancestors.6a15f624.jpg";